export const buildInitialState = () => ({
  dados: {}, // {id_cliente: {portfolios: []}}
})

export default buildInitialState()
